import React from 'react';
function NewsletterPost(props) {
    const { data: {acf_blog_newsletter} } = props;
    const {title, description, form_code} = acf_blog_newsletter;
    return <div className="archive-newsletter-post" id="archive-newsletter-post">
                <div className="archive-newsletter-post__wrapper">
                    <h3 className="archive-newsletter-post__title" dangerouslySetInnerHTML={{ __html: title }} />
                    <p className="archive-newsletter-post__description" dangerouslySetInnerHTML={{ __html: description }} />
                    <div className="archive-newsletter-post__form hbspt-form newsletter-post" id="hubspot-form" dangerouslySetInnerHTML={{ __html: form_code }} />
                </div>
            </div>
}
export default NewsletterPost;